import * as React from 'react';
import { Navigate, RouteObject } from 'react-router';

import { LocalizedPathRedirect } from '../../pages/redirects';
import { RouteGuard } from './RouteGuard';
interface RouteConfig {
    path: string;
    component: () => Promise<{ default: () => React.JSX.Element }>;
}

type LazyComponent = React.LazyExoticComponent<() => React.JSX.Element>;

export const ROUTES = {
    SIGNUP: {
        path: '/',
        component: () => import('../../pages/createtenant')
    },
    LOGIN: {
        path: '/login',
        component: () => import('../../pages/login')
    }
} as const satisfies Record<string, RouteConfig>;

export type RouteKey = keyof typeof ROUTES;

const lazyComponents = Object.fromEntries(
    Object.entries(ROUTES).map(([key, config]) => [
        key,
        React.lazy(config.component)
    ])
) as Record<RouteKey, LazyComponent>;

export const routesConfig: RouteObject[] = [
    ...Object.entries(ROUTES).flatMap(([routeKey, routeConfig]) => {
        const LazyComponent = lazyComponents[routeKey as RouteKey];

        return [
            {
                path: routeConfig.path,
                element: <LocalizedPathRedirect page={routeKey as RouteKey} />
            },
            {
                path: `/:country${routeConfig.path === '/' ? '' : routeConfig.path}`,
                element: (
                    <RouteGuard>
                        <LazyComponent />
                    </RouteGuard>
                )
            }
        ];
    }),

    { path: '*', element: <Navigate to="/" /> }
];
